import React, { useState, useEffect } from "react";
import { useForm, Controller } from "react-hook-form";
import { RootState } from "app/lib/store/store";
import { useDispatch, useSelector } from "react-redux";
import {
  nextStep,
  prevStep,
  addStepsData,
  setSavedIds,
  addJointApplicationData,
} from "app/lib/store/slices/steps/loanTypesSteps";
import { addStepsData as addIndividualIncome } from "app/lib/store/slices/steps/incomeDetails";
import { useLoanApplication } from "app/hooks/application/useLoanApplication";
import toast from "react-hot-toast";
import MainTitle from "app/components/common/typography/MainTitle";
import ContinueButton from "app/components/common/buttons/Continue";
import PreviousButtom from "app/components/common/buttons/Previous";
import ProgressBar from "app/components/common/progressbar/ProgressBar";
import SubTitle from "app/components/common/typography/SubTitle";
import Checkbox from "app/components/common/inputs/Checkbox";
import ErrorsMessage from "app/components/common/errors/ErrorsMessage";
import Loader from "app/components/common/Loader";
import { useUpdateApplicationStatus } from "app/hooks/applicant/useUpdateApplicationStatus";
import { attachSavedIdsToPayload } from "app/utils/transformApplicantPayload";
import PhoneNumberInput from "app/components/common/inputs/PhoneNumberInput";
import { isValidPhoneNumber } from "react-phone-number-input";
import { openPrivacyPage, openTermConditionsPage } from "app/utils";
import { handleApiError } from "app/utils/handleApiError";
import { normalizeSavedIncomes } from "app/utils/normalizeIncome";

interface FormData {
  termsAccepted: boolean;
  newslettersAccepted: boolean;
  phoneNumber: string;
}

const SecureYourAccount: React.FC = () => {
  const dispatch = useDispatch();
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);
  const { mutate, isPending } = useLoanApplication();
  const { mutate: updatemutate, isPending: updateisPending } =
    useUpdateApplicationStatus();
  const applicantData = useSelector(
    (state: RootState) => state.loanTypesSteps.stepsData
  );
  const { loanApplication, vehicleDetail, ...othersData } = useSelector(
    (state: RootState) => state.loanTypesSteps.stepsData
  );

  const JointapplicationData = useSelector(
    (state: RootState) => state.loanTypesSteps.jointApplication
  );

  const { applicants, ...remaingData } = useSelector(
    (state: RootState) => state.loanTypesSteps.stepsData
  );
  const isjointApplication =
    remaingData && remaingData?.loanApplication?.applicationType === "joint";
  const applicantsSavedIds = useSelector(
    (state: RootState) => state.loanTypesSteps.savedIds
  );

  const isApplicationFailed =
    applicantsSavedIds?.applicationStatus === "declined";

  const {
    control,
    handleSubmit,
    formState: { errors },
    watch,
    setValue,
  } = useForm<FormData>({
    defaultValues: {
      newslettersAccepted: false,
    },
  });

  const watchTermsAccepted = watch("termsAccepted", false);

  useEffect(() => {
    setIsButtonDisabled(!watchTermsAccepted);
  }, [watchTermsAccepted]);

  const onSubmit = (data: FormData) => {
    let phoneNumber = data.phoneNumber;
    let payload = {} as any;
    if (!isjointApplication) {
      const updatedApplicant = structuredClone(applicants) || {};
      if (phoneNumber) {
        updatedApplicant.phoneNumber = phoneNumber;
      }
      dispatch(
        addStepsData({
          applicants: updatedApplicant,
          ...remaingData,
        })
      );
      const updatedApplicantData = structuredClone(applicantData);
      // delete updatedApplicantData.applicants?.mailingAddress;
      delete updatedApplicantData?.vehicleDetail?.manuallyModel;
      delete updatedApplicantData?.vehicleDetail?.isCarManuallyModel;
      // delete updatedApplicantData?.vehicleDetail?.brandName;

      payload = {
        ...updatedApplicantData,
        applicants: Array.isArray(updatedApplicantData.applicants)
          ? updatedApplicantData.applicants.map((app: any) => ({
              ...app,
              phoneNumber,
            }))
          : [
              {
                ...updatedApplicantData.applicants,
                phoneNumber,
              },
            ],
      };
      console.log(JSON.stringify(payload));
    } else {
      const yourDetailsData = {
        ...JointapplicationData.YourDetails,
        phoneNumber: phoneNumber,
      };
      dispatch(
        addJointApplicationData({
          category: "YourDetails",
          data: yourDetailsData,
        })
      );
      const updatedApplicant = {
        ...remaingData,
        applicants: [
          JointapplicationData?.YourDetails
            ? { ...JointapplicationData.YourDetails, phoneNumber: phoneNumber }
            : null,
          JointapplicationData?.Coborrower || null,
        ].filter(Boolean), // Removes any null/undefined values
      };
      const updatedcoApplicant = structuredClone(updatedApplicant) || {};
      delete updatedcoApplicant?.vehicleDetail?.manuallyModel;
      delete updatedcoApplicant?.vehicleDetail?.isCarManuallyModel;
      // if (Array.isArray(updatedcoApplicant.applicants)) {
      //   updatedcoApplicant.applicants.forEach((app: any) => {
      //     // delete app.mailingAddress;
      //   });
      // }
      payload = updatedcoApplicant;
    }
    console.log(JSON.stringify(payload));

    if (!isApplicationFailed) {
      mutate(payload, {
        onSuccess: (data) => {
          toast.success("OTP has been sent successfully");

          const { loanApplication } = data || {};
          let savedIds = {};

          if (loanApplication.applicationType === "joint") {
            const sortedApplicants = [
              ...data?.loanApplication?.applicantLoanApplications?.filter(
                (a: any) => a.isPrimary
              ),
              ...data?.loanApplication?.applicantLoanApplications?.filter(
                (a: any) => !a.isPrimary
              ),
            ];
            const mainApplicant = sortedApplicants?.[0]?.applicant;
            const childApplicant = sortedApplicants?.[1]?.applicant;

            savedIds = {
              applicantID: mainApplicant?.id,
              employmentID: mainApplicant?.employment?.id,
              incomeIDs:
                mainApplicant?.incomes?.map((income: any) => income.id) || [],
              secondIncomeIDs:
                childApplicant?.incomes?.map((income: any) => income.id) || [],
              liabilitieID: mainApplicant?.liabilities?.id,
              secondliabilitieID: childApplicant?.liabilities?.id,
              vehicleDetailID: data?.loanApplication?.vehicleDetail?.id,
              loanApplicationID: data?.loanApplication?.id,
              secondEmploymentID: childApplicant?.employment?.id,
              secondApplicantID: childApplicant?.id,
              bankDocLink: mainApplicant?.linkUrl,
              secondBankDocLink: childApplicant?.linkUrl,
            };
          } else {
            const applicant =
              data?.loanApplication?.applicantLoanApplications?.[0]?.applicant;

            savedIds = {
              incomeIDs:
                applicant?.incomes?.map((income: any) => income.id) || [],
              liabilitieID: applicant?.liabilities?.id,
              applicantID: applicant?.id,
              employmentID: applicant?.employment?.id,
              vehicleDetailID: data?.loanApplication?.vehicleDetail?.id,
              loanApplicationID: data?.loanApplication?.id,
              bankDocLink: applicant?.linkUrl,
            };
          }
          dispatch(setSavedIds(savedIds));
          dispatch(nextStep());
        },
        onError: (err: any) => {
          handleApiError(err);
        },
      });
    } else {
      attachSavedIdsToPayload(payload, applicantsSavedIds);
      updatemutate(
        {
          url: `/loan-application/${applicantsSavedIds?.loanApplicationID}/update-application`,
          data: payload,
        },
        {
          onSuccess: (data) => {
            const { loanApplication } = data || {};
            const loanApplicationData = loanApplication;

            let savedIds = {};
            if (loanApplication.applicationType === "joint") {
              const sortedApplicants = [
                ...data?.applicants?.filter((a: any) => a.isPrimary),
                ...data?.applicants?.filter((a: any) => !a.isPrimary),
              ];
              const mainApplicant = sortedApplicants?.[0];
              const childApplicant = sortedApplicants?.[1];

              savedIds = {
                applicantID: mainApplicant?.id,
                employmentID: mainApplicant?.employment?.id,
                incomeIDs:
                  mainApplicant?.incomes?.map((income: any) => income.id) || [],
                secondIncomeIDs:
                  childApplicant?.incomes?.map((income: any) => income.id) ||
                  [],
                liabilitieID: mainApplicant?.liabilities?.id,
                secondliabilitieID: childApplicant?.liabilities?.id,
                vehicleDetailID: data?.vehicleDetail?.id,
                loanApplicationID: data?.loanApplication?.id,
                secondEmploymentID: childApplicant?.employment?.id,
                secondApplicantID: childApplicant?.id,
                bankDocLink: mainApplicant?.linkUrl,
                secondBankDocLink: childApplicant?.linkUrl,
              };
            } else {
              const applicantsData = data?.applicants[0];
              const vehicleDetailData = data?.vehicleDetail;

              const incomeData = applicantsData?.incomes ?? [];
              const expensesData = applicantsData?.expenses ?? [];

              // update the income

              const formattedIncomes = normalizeSavedIncomes(incomeData);
              if (formattedIncomes && formattedIncomes?.length > 0) {
                dispatch(addIndividualIncome({ income: formattedIncomes }));
              }

              dispatch(
                addStepsData({
                  ...othersData,
                  loanApplication: {
                    ...loanApplication,
                    id: loanApplication?.id,
                  },
                  vehicleDetail: {
                    ...vehicleDetail,
                    id: vehicleDetailData?.id,
                  },
                  applicants: {
                    ...othersData.applicants,
                    id: applicantsData?.id,
                    incomes: othersData?.applicants?.incomes?.map(
                      (item: any, index: number) => ({
                        ...item,
                        id: applicantsData?.incomes?.[index]?.id ?? item.id,
                      })
                    ),
                    expenses: expensesData?.map((item: any, index: number) => ({
                      id: item.id,
                      type: item.type,
                      amount: Number(item.amount),
                    })),
                    employment: {
                      ...othersData?.applicants?.employment,
                      id: applicantsData?.employment?.id,
                    },
                    liabilities: {
                      ...othersData?.applicants?.liabilities,
                      id: applicantsData?.liabilities?.id,
                    },
                  },
                })
              );

              savedIds = {
                incomeIDs:
                  applicantsData?.incomes?.map((income: any) => income.id) ||
                  [],
                liabilitieID: applicantsData?.liabilities?.id,
                applicantID: applicantsData?.id,
                employmentID: applicantsData?.employment?.id,
                vehicleDetailID: data?.vehicleDetail?.id,
                loanApplicationID: data?.loanApplication?.id,
                bankDocLink: applicantsData?.linkUrl,
              };
            }
            dispatch(setSavedIds(savedIds));
            dispatch(nextStep());
          },
          onError: (err: any) => {
            toast.error(
              err?.response?.data?.message || "something went wrong."
            );
          },
        }
      );
    }
  };

  useEffect(() => {
    const removeCountryCode = (phoneNumber: string) => {
      return phoneNumber.startsWith("61") ? phoneNumber.slice(2) : phoneNumber;
    };
    if (applicants?.phoneNumber && !isjointApplication) {
      setValue("phoneNumber", removeCountryCode(applicants?.phoneNumber));
      setValue("termsAccepted", true);
      // setValue("newslettersAccepted", true);
    } else if (JointapplicationData?.YourDetails?.phoneNumber) {
      // setValue("phoneNumber", JointapplicationData?.YourDetails?.phoneNumber);
      setValue(
        "phoneNumber",
        removeCountryCode(JointapplicationData?.YourDetails?.phoneNumber)
      );
      setValue("termsAccepted", true);
      // setValue("newslettersAccepted", true);
    }
  }, [applicants?.phoneNumber, setValue]);

  return (
    <>
      {(isPending || updateisPending) && <Loader />}
      <ProgressBar progress={100} />
      <div className="w-full  sm:w-[70%] xl:w-[40%]  mx-auto text-center px-4 sm:px-0">
        <MainTitle title="Verify Your Identity" />
        <SubTitle title="Enter your mobile number to verify your identity via SMS. This step is required to view your loan eligibility results." />

        <form onSubmit={handleSubmit(onSubmit)} className="text-left">
          <div className="text-left">
            <label className="block font-Mulish text-base font-normal text-lightBlue mb-1">
              Phone number
            </label>
            <Controller
              name="phoneNumber"
              control={control}
              rules={{
                required: "Phone number is required",
                validate: (value) =>
                  isValidPhoneNumber(value || "") ||
                  "Please enter a valid phone number",
              }}
              render={({ field: { onChange, value } }) => (
                <PhoneNumberInput
                  value={value}
                  onChange={onChange}
                  error={!!errors.phoneNumber}
                />
              )}
            />
          </div>

          {errors.phoneNumber && (
            <ErrorsMessage title={errors.phoneNumber.message} />
          )}
          <div className="text-left mt-5">
            <Controller
              name="termsAccepted"
              control={control}
              rules={{ required: "You must agree to the terms" }}
              render={({
                field: { onChange, value },
                fieldState: { error },
              }) => (
                <>
                  <div className="mb-3 ">
                    <Checkbox
                      id="termsAccepted"
                      labelClassName="sm:mt-[-15px]"
                      labelHtml={
                        <p className="text-[14px] font-Mulish">
                          By continuing, you agree to our{" "}
                          <span
                            className="text-[#D1A960] cursor-pointer hover:underline"
                            onClick={openTermConditionsPage}
                          >
                            Terms of Service
                          </span>{" "}
                          and{" "}
                          <span
                            className="text-[#D1A960] cursor-pointer hover:underline"
                            onClick={openPrivacyPage}
                          >
                            Privacy Policy
                          </span>
                          .
                        </p>
                      }
                      checked={value}
                      onChange={(e) => onChange(e.target.checked)}
                    />
                    {error && <ErrorsMessage title={error.message} />}
                  </div>
                </>
              )}
            />

            <Controller
              name="newslettersAccepted"
              control={control}
              // rules={{ required: "You must agree to the terms to proceed." }}
              render={({
                field: { onChange, value },
                fieldState: { error },
              }) => (
                <>
                  <div className="mb-3 sm:mb-1">
                    <Checkbox
                      id="newslettersAccepted"
                      labelClassName="sm:mt-[-15px] text-[14px] font-Mulish"
                      labelHtml={
                        <p className="text-[14px] font-Mulish">
                          I agree to receive newsletters and promotional
                          updates.
                          <span className="text-[#98A2B3]">
                            (optional)
                          </span>{" "}
                          {/* <span className="text-[#D1A960] cursor-pointer hover:underline">
                            Promotional Content
                          </span>
                          . */}
                        </p>
                      }
                      checked={value}
                      onChange={(e) => onChange(e.target.checked)}
                    />
                    {/* {error && <ErrorsMessage title={error.message} />} */}
                  </div>
                </>
              )}
            />
          </div>
          <div className="flex justify-between my-10">
            <PreviousButtom
              onClick={() => dispatch(prevStep())}
              loading={false}
            >
              Previous
            </PreviousButtom>
            <ContinueButton
              type="submit"
              loading={isPending}
              disabled={isButtonDisabled}
            >
              Next
            </ContinueButton>
          </div>
        </form>
      </div>
    </>
  );
};

export default SecureYourAccount;
